// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3N3mg","productName":"Table_productName__2A-Ev"};